import { HYPERVISORS_MAP } from '@/constants'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  data () {
    return {
      // 维度类型
      dimensionTypeList: [
        {
          key: this.$t('bill.text_73'),
          value: 'resource_type',
        },
        {
          key: this.$t('bill.usage_type'),
          value: 'bill',
        },
        {
          key: this.$t('bill.text_76'),
          value: 'domain',
        },
        {
          key: this.$t('bill.project'),
          value: 'project',
        },
      ],
      // 参数类型
      dimensionParamsMap: {
        bill: {
          name: 'dimensions_analysis',
          id: 'dimension_analysis_ids',
        },
        resource_type: {
          name: 'dimensions_analysis',
          id: 'dimensions_analysis',
        },
        project: {
          name: 'dimension_projects',
          id: '',
        },
        domain: {
          name: 'dimension_domains',
          id: '',
        },
      },
      domainList: [],
      projectList: [],
    }
  },
  created () {
    this.$d = new this.$Manager('domains', 'v1')
    this.$p = new this.$Manager('projects', 'v1')
  },
  methods: {
    dimensionTag (item, dimension_type) {
      const { usage_type = '', brand = '', resource_type = '', description = '' } = item
      let resultStr = ''
      const brandConfig = HYPERVISORS_MAP[brand.toLowerCase()] || {}
      const brandInfo = { key: item, label: brandConfig.label || '' }
      if (brandInfo.label === 'OneCloud') {
        brandInfo.label = this.$t('brand')
      }
      if (dimension_type === 'bill') {
        resultStr += usage_type
        resultStr += usage_type && (brand || resource_type || description) ? '(' : ''
        resultStr += brandInfo.label || brand
        resultStr += (brand && (resource_type || description)) ? '-' : ''
        resultStr += getBillResourceTypeLabel(resource_type)
        resultStr += description ? '-' : ''
        resultStr += description
        resultStr += usage_type && (brand || resource_type || description) ? ')' : ''
      } else if (dimension_type === 'resource_type') {
        resultStr += getBillResourceTypeLabel(resource_type)
        resultStr += (resource_type && brand) ? '-' : ''
        resultStr += brandInfo.label || brand
      } else if (dimension_type === 'domain') {
        resultStr += item.name || ''
      } else if (dimension_type === 'project') {
        resultStr += item.name || ''
      }
      return resultStr
    },
    fetchDataCallback () {
      try {
        const { data } = this.list
        const domainIds = []
        const projectIds = []
        for (const id in data) {
          const obj = data[id].data || {}
          const { dimension_items = [] } = obj
          dimension_items.map(item => {
            if (item.dimension_domains) {
              item.dimension_domains.map(item2 => {
                domainIds.push(item2.domain_id)
              })
            }
            if (item.dimension_projects) {
              item.dimension_projects.map(item2 => {
                projectIds.push(item2.project_id)
              })
            }
          })
        }
        if (domainIds.length) {
          this.fetchDomains(domainIds)
        }
        if (projectIds.length) {
          this.fetchProjects(projectIds)
        }
      } catch (err) { }
    },
    async fetchDomains (ids) {
      const domains = await this.$d.list({
        params: {
          filter: `id.in(${ids})`,
          cancelToken: true,
          scope: this.$store.getters.scope,
        },
      })
      this.domainList = domains.data.data || []
      this.$bus.$emit('dimensionDomainUpdated', this.domainList)
    },
    async fetchProjects (ids) {
      const projects = await this.$p.list({
        params: {
          filter: `id.in(${ids})`,
          cancelToken: true,
          scope: this.$store.getters.scope,
        },
      })
      this.projectList = projects.data.data || []
      this.$bus.$emit('dimensionProjectUpdated', this.projectList)
    },
  },
}
